import coreHelpers from '@core/js/helpers';

export default {
    install(Vue) {
        Vue.prototype.$dictionary = (key) => {
            return coreHelpers.dictionary.get(key);
        };
    },
};
